import { useEffect, useState } from "react";
import { CheckCircle, ShoppingCartSimple, X } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export const CartAddNotification = ({ notification, onDismiss }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!notification) return undefined;
    setVisible(false);
    const enterTimer = setTimeout(() => setVisible(true), 20);
    const leaveTimer = setTimeout(() => setVisible(false), 2400);
    const dismissTimer = setTimeout(onDismiss, 2800);
    return () => {
      clearTimeout(enterTimer);
      clearTimeout(leaveTimer);
      clearTimeout(dismissTimer);
    };
  }, [notification, onDismiss]);

  if (!notification) return null;

  const viewCart = (event) => {
    event.preventDefault();
    window.location.assign("/cart");
  };

  return (
    <div data-testid="cart-add-notification-viewport" className="pointer-events-none fixed inset-x-4 bottom-4 z-[120] flex justify-center sm:inset-x-auto sm:right-6 sm:justify-end">
      <section data-testid="cart-add-notification" className={`pointer-events-auto w-full max-w-sm border border-[#D5D1C4] bg-[#F7F2EA] p-4 text-[#1A3626] shadow-[0_18px_50px_rgba(17,24,21,0.28)] transition-[opacity,transform] duration-300 ${visible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`} role="status" aria-live="polite">
        <div className="flex items-start gap-3">
          <span data-testid="cart-add-notification-icon" className="grid h-10 w-10 shrink-0 place-items-center bg-[#1A3626] text-white"><CheckCircle size={22} weight="duotone" /></span>
          <div className="min-w-0 flex-1">
            <p data-testid="cart-add-notification-title" className="text-sm font-bold uppercase tracking-[0.18em] text-[#1A3626]">Added to cart ✓</p>
            <p data-testid="cart-add-notification-product" className="mt-1 truncate text-sm text-[#5C6A61]">{notification.title}</p>
            <Button asChild className="mt-3 h-9 rounded-none bg-[#C26B51] px-4 text-xs uppercase tracking-[0.16em] text-white hover:bg-[#A85743]"><a data-testid="cart-add-notification-view-cart" href="/cart" onClick={viewCart}><ShoppingCartSimple size={16} /> View cart</a></Button>
          </div>
          <button data-testid="cart-add-notification-dismiss" type="button" className="text-[#5C6A61] transition-colors hover:text-[#1A3626]" onClick={onDismiss} aria-label="Dismiss cart notification"><X size={17} /></button>
        </div>
      </section>
    </div>
  );
};